// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__He-BE","controls":"styles_controls__2Hzg8","charLimit":"styles_charLimit__1XhLC","input":"styles_input__2VWue","send":"styles_send__3FXck"};